import { useLocalStorageState } from '@frontend/common';
import { useEffect, useRef, useState } from 'react';

import { IdleTimerProps } from './idle-timer.component';

export const IDLE_TIMER_KEY = 'inactivity_timer_enabled';
const timeUntilIdleSeconds = process.env['NX_PUBLIC_BUILD_ENV'] === 'development' ? 1000000 : 60;
const showSeconds = process.env['NX_PUBLIC_BUILD_ENV'] === 'development' ? 999990 : 45;
export interface IdleTimerViewProps {
    enabled: boolean;
    almostInActive: boolean;
    timeUntilInactive: number;
    onClick: (e: any) => void;
}

const useIdleTimer = (props: IdleTimerProps): IdleTimerViewProps => {
    const [lastActivity, changeLastActivity] = useState(new Date());
    const [tickDate, changeTickDate] = useState(Date.now());
    const [enabled] = useLocalStorageState(IDLE_TIMER_KEY, false);

    const inActive = tickDate - lastActivity.getTime() > timeUntilIdleSeconds * 1000;
    const almostInActive = tickDate - lastActivity.getTime() > showSeconds * 1000;
    const timeUntilInactive = Math.ceil((timeUntilIdleSeconds * 1000 - (tickDate - lastActivity.getTime())) / 1000);

    const enabledRef = useRef(enabled);
    enabledRef.current = enabled;
    const almostInActiveRef = useRef(almostInActive);
    almostInActiveRef.current = almostInActive;
    const handler = (e?: any) => {
        if (enabledRef.current && almostInActiveRef.current) {
            e.preventDefault();
            e.stopPropagation();
        }
        changeLastActivity(new Date());
    };

    useEffect(() => {
        let timerId: number | undefined = undefined;
        if (enabled) {
            handler();
            addHandlers(handler);
            changeTickDate(Date.now());
            timerId = window.setInterval(() => {
                changeTickDate(Date.now());
            }, 500);
        }
        return () => {
            if (timerId !== undefined) window.clearInterval(timerId);
            removeHandlers(handler);
        };
    }, [enabled]);

    useEffect(() => {
        if (enabled && inActive && tickDate != 0) {
            changeTickDate(0);
            props.idleCallback && props.idleCallback();
        }
    }, [inActive, enabled, props.idleCallback]);

    const onClick = (e: any) => {
        e.stopPropagation();
        e.preventDefault();
        triggerActivity();
    };

    return {
        enabled,
        almostInActive,
        timeUntilInactive,
        onClick
    };
};

export default useIdleTimer;

function addHandlers(handler: (e?: any) => void) {
    window.addEventListener('touchend', handler);
    window.addEventListener('kiosk_activity', handler);
}

function removeHandlers(handler: (e?: any) => void) {
    window.removeEventListener('touchend', handler);
    window.removeEventListener('kiosk_activity', handler);
}
/**
 * Function used to reset idle timer.
 */
export function triggerActivity() {
    window.dispatchEvent(new CustomEvent('kiosk_activity'));
}
